/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Sales {

    import fld = SalesQuotationItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.registerEditor()
    export class SalesQuotationItemsEditor extends _Ext.ItemGridEditor<SalesQuotationItemsRow> {
        protected getColumnsKey() { return "Sales.QuotationItems"; }
        protected getDialogType() { return SalesQuotationItemsDialog; }
        protected getLocalTextPrefix() { return SalesQuotationItemsRow.localTextPrefix; }

        protected form: SalesQuotationItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = true;
            return opt;
        }
        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public MarkUpPolicyId: number;

        public DeptId: number;
        public TransDate: Date;
        public TotalItems: number;
        public ProductTypeId: number;
        statement: string;
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as SalesQuotationDialog).CalculateAmountandTax();
                }
            })
        }


        protected createToolbarExtensions(): void {
            super.createToolbarExtensions();
        }

        private getItem(SKU: string) {
            var StockID = [];
            Stock.StockItemService.GetStockTransactions({
                SKU: SKU

            },
                response => StockID = response.Entities,
                {
                    async: false
                });

            var Quantity = 0;
            if (StockID.length > 0) {
                for (var x of StockID) {

                    Quantity += x.Pieces;

                };

                if (Quantity > 0) {
                    var Item = StockID.pop();


                }
            }

        }


        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Discount).format = num;
            Q.first(columns, x => x.field === fld.WstPer).format = num;
            Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = num;

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        //**** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);
                        this.element.trigger('dialogclose');

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            if (target.hasClass('edit numeric')) {
                e.preventDefault();

                if (target.hasClass('edit numeric')) {
                    // var x = Q.coalesce(Q.trimToNull(input.val()), '0');
                    //TODO: Need to add System Parameter to enable disable blocking
                    var input = $(e.target);
                    if (input != undefined) {
                        if (this.canUpdate == 0) {
                            //Check Editable
                            target.addClass('readonly');
                            target.blur();
                            Q.alert("Readonly Detected")

                        }
                        else if (this.canUpdate == 1) {
                            target.removeClass('readonly');
                            var input = $(e.target);
                            var y = input.data();
                            if (y.field == "Weight" && item.ItemTypeId == 101) {
                                target.addClass('readonly');
                                target.blur();
                            }
                            else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                                target.addClass('readonly');
                                target.blur();
                            }
                        }
                    }

                    this.view.refresh();
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            let _value = ValidateEditorFields(field, input, text, oldText);
            let value: number;
            if (q.isNumber(_value))
                value = parseFloat(_value.toString());
            else
                return false;


            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;
                }

            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {
                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;

                    item[field] = value;
                }

            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {
                if (item.CalcOnId == 4 || item.CalcOnId == 5) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;

                    item[field] = value;
                }
            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            item.CCGrossAmount = item.GrossAmount * this.ExchangeRate;
            item.CCNetAmount = item.NetAmount * this.ExchangeRate;

            this.view.updateItem(id, item);
            this.view.refresh();
            this.element.trigger('dialogclose');


            let returnvalue: string = "";
            if (input.hasClass('numeric'))
                returnvalue = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                returnvalue = Q.formatNumber(value, '0');

            input.val(returnvalue).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion

        setMasterValues() {
            this.RateListId = (this.parentDialog as SalesQuotationDialog).RateListId;
            this.LaborListId = (this.parentDialog as SalesQuotationDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as SalesQuotationDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as SalesQuotationDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as SalesQuotationDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as SalesQuotationDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as SalesQuotationDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as SalesQuotationDialog).form.TransDate.valueAsDate;
            this.PartyId = parseInt((this.parentDialog as SalesQuotationDialog).form.PartyId.value);
            this.MarkUpPolicyId = (this.parentDialog as SalesQuotationDialog).MarkUpPolicyId;
        }

        // #region Buttons Add-Remove
        protected getButtons() {
            let self = this;
            let buttons = super.getButtons();
            buttons.filter(x => x.cssClass == "add-button")[0].visible = false;
            var addbutton = buttons.filter(x => x.cssClass == "add-button")[0];
            buttons.push({
                title: "New Product",
                cssClass: "add-button",
                hotkey: "alt+n",
                hint: 'alt+n',
                onClick: () => {
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (this.PartyId == 0 || this.PartyId == null || isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {

                        addbutton.onClick();
                    }

                }
            });
            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "alt+k",
                onClick: () => {
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;

                    } else {

                        //OMS.ProductSelectGrid.ItemType = 1;
                        var grid = Common.ProductSelectGrid;
                        var filters: _Ext.SelectGridFilters = {
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetSalesOrderGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup, this.MarkUpPolicyId);
                        this.setData(ItemDetails);
                    }
                    pickerDialog.dialogOpen();
                }
            });


            return buttons;
        }
        setData(ItemDetails: SalesQuotationItemsRow[]) {
            for (let Itemdetail of ItemDetails) {
                //if (Itemdetail.SpecialRemark == "" || Itemdetail.SpecialRemark == null) {
                //    Purchase.PurchaseItemsService.List({ ProductCode:Itemdetail.ProductCode }, response => {
                //        Itemdetail.SpecialRemark = response.Entities[0].SpecialRemark
                //    }, { async:false })
                //}
                Itemdetail.Line_No = null;
                Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(Itemdetail);
            }
        }


        // #endregion

    }
} 